<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-layout mt-5>
      <v-flex xs12>
        <div :class="paginatedItems.length === 5 ? 'warrant_box' : 'warrant_box_empty'">
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;"> Grower Payments </span>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs3>
                <v-autocomplete
                  name="name"
                  v-model="chargetype.name"
                  :items="chargetypes"
                  item-text="name"
                  item-value='name'
                  @input="updateChargeType"
                  label="Charge Type"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>

            <table class="table" v-if="chargetype.name === 'BROKER'">
              <thead class="thead">
              <tr>
                <th scope="col">Eslip Number</th>
                <th scope="col">Broker Amount</th>
                <th scope="col">CleanCoffee</th>
                <th scope="col">ParchmentOutturn</th>
                <th scope="col">Grower Code</th>
                <!-- <th scope="col">Eslip Amount</th> -->
                <th scope="col">Broker Code</th>
                <th scope="col">Nce Amount</th>
                <!-- <th scope="col">Status</th> -->
                <th scope="col">DateCreated</th>
                <!-- <th scope="col">Actions</th> -->
              </tr>
              </thead>
              <tbody>


              <tr v-for="item in brokerPayments" v-bind:key="item.id">
                <td> {{ item.eslipNumber }} </td>
                <td> {{ item.brokerAmount }} </td>
                <td> {{ item.cleanCoffeeOutTurn }} </td>
                <td> {{ item.parchmentOutTurn }} </td>
                <td> {{ item.growerCode }}</td>

                <td> {{ item.brokerCode }}</td>
                <td> {{ item.nceAmount }}</td>

                <td> {{ item.dateCreated | prettyDate }}</td>

              </tr>


              </tbody>
            </table>
            <table class="table" v-if="chargetype.name === 'MILLER'">
              <thead class="thead">
              <tr>
                <th scope="col">Eslip Number</th>
                <th scope="col">CleanCoffee</th>
                <th scope="col">ParchmentOutturn</th>
                <!-- <th scope="col">Eslip Amount</th> -->
                <th scope="col">Miller Code</th>
                <th scope="col">Miller Amount</th>
                <th scope="col">Status</th>
                <th scope="col">DateCreated</th>
                <th scope="col">Status</th>
                <!--                <th v-if="canUpdateMillingChargeOnSettlement && item['millerChargeStatus']['statusName'] == 'PENDING_MILLER_CHARGE_UPDATE'" scope="col">Actions</th>-->
                <!--                <th v-if="canUpdateMillingChargeOnSettlement || canApproveMillingChargeOnSettlement" scope="col">Actions</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in millerPayments" v-bind:key="item.id">
                <td> {{ item.eslipNumber }} </td>
                <td> {{ item.cleanCoffeeOutTurn }} </td>
                <td> {{ item.parchmentOutTurn }} </td>
                <!-- <td> {{ item.eslipAmount }}</td> -->
                <td> {{ item.millerCode }}</td>
                <td> {{ item.millerAmount }}</td>
                <td> {{ item.status.statusName }}</td>
                <td> {{ item.dateCreated | prettyDate }}</td>
                <td> {{ item.millerChargeStatus.statusName }}</td>
                <td> <v-menu offset-y v-if="(canUpdateMillingChargeOnSettlement &&
                item['millerChargeStatus']['statusName'] == 'PENDING_CHARGE_UPDATE') ||
                (canUpdateMillingChargeOnSettlement && (item['millerChargeStatus']['statusName'] == 'PENDING_CHARGE_APPROVAL'||item['millerChargeStatus']['statusName'] == 'CHARGE_REJECTED'))" >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon

                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="updateMillerAmount(item)">Edit Charge </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu></td>
                <!--                <td> <v-btn v-if="canUpdateMillingChargeOnSettlement" color="secondary" @click="updateMillerAmount(item)">Edit Charge</v-btn></td>-->
                <!--                <td> <v-btn v-if="canApproveMillingChargeOnSettlement && item['millerChargeStatus']['statusName'] == 'PENDING_MILLER_CHARGE_APPROVAL'" color="secondary"  @click="approveRejectMillerCharge(item)">Approve/Reject Charge</v-btn></td>-->
                <td> <v-menu offset-y v-if="canApproveMillingChargeOnSettlement && item['millerChargeStatus']['statusName'] == 'PENDING_CHARGE_APPROVAL'" >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon

                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="approveRejectChargeShowDialog(item, 1)"> Approve </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="approveRejectChargeShowDialog(item, 0)"> Reject </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu></td>
              </tr>
              </tbody>
            </table>
               <table class="table" v-if="chargetype.name === 'WAREHOUSE'">
              <thead class="thead">
              <tr>
                <th scope="col">Eslip Number</th>
                <th scope="col">CleanCoffee</th>
                <th scope="col">ParchmentOutturn</th>
                <!-- <th scope="col">Eslip Amount</th> -->
                <th scope="col">Warehouse Code</th>
                <th scope="col">Warehouse Amount</th>
                <th scope="col">Status</th>
                <th scope="col">DateCreated</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
                <!--                <th v-if="canUpdateMillingChargeOnSettlement && item['millerChargeStatus']['statusName'] == 'PENDING_MILLER_CHARGE_UPDATE'" scope="col">Actions</th>-->
                <!--                <th v-if="canUpdateMillingChargeOnSettlement || canApproveMillingChargeOnSettlement" scope="col">Actions</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in warehousePayments" v-bind:key="item.id">
                <td> {{ item.eslipNumber }} </td>
                <td> {{ item.cleanCoffeeOutTurn }} </td>
                <td> {{ item.parchmentOutTurn }} </td>
                <!-- <td> {{ item.eslipAmount }}</td> -->
                <td> {{ item.warehouseCode }}</td>
                <td> {{ item.warehouseAmount }}</td>
                <td> {{ item.status.statusName }}</td>
                <td> {{ item.dateCreated | prettyDate }}</td>
                <td> {{ item.warehouseChargeStatus.statusName }}</td>
                <td> <v-menu offset-y v-if="canUpdateMillingChargeOnSettlement && (item.warehouseChargeStatus.statusName == 'PENDING_CHARGE_UPDATE'
                ||item['warehouseChargeStatus']['statusName'] == 'CHARGE_REJECTED')" >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon

                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="updateWarehouseAmount(item)">Edit Charge </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu></td>
                <!--                <td> <v-btn v-if="canUpdateMillingChargeOnSettlement" color="secondary" @click="updateMillerAmount(item)">Edit Charge</v-btn></td>-->
                <!--                <td> <v-btn v-if="canApproveMillingChargeOnSettlement && item['millerChargeStatus']['statusName'] == 'PENDING_MILLER_CHARGE_APPROVAL'" color="secondary"  @click="approveRejectMillerCharge(item)">Approve/Reject Charge</v-btn></td>-->
                <td> <v-menu offset-y v-if="canApproveMillingChargeOnSettlement && item['warehouseChargeStatus']['statusName'] == 'PENDING_CHARGE_APPROVAL'" >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon

                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="approveRejectWarehouseChargeShowDialog(item, 1)"> Approve </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="approveRejectWarehouseChargeShowDialog(item, 0)"> Reject </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu></td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="editMillerChargeDialog" persistent max-width="350">
      <template>
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text">Update Milling Charge</v-card-title>
          <v-card-text>
            <v-container grid-list-xl fluid>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <v-flex xs12>
                      <v-text-field
                        label="Milling Charge"
                        min="1"
                        type="number"
                        v-model="millingCharge"
                        :error-messages="millerchargeErrorMessages"
                        @input="validateMillingCharge"

                      ></v-text-field>
                  <!-- <v-flex xs12>
                    <v-text-field label="Milling Charge" min="1" type="number" v-model="millingCharge"></v-text-field>
                    <label class="custom-form-error milling-charge-error" for="contract"></label> -->
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="editMillerChargeDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary"  @click="updateMillingCharge">Submit</v-btn>
            <v-progress-circular v-show="updateMillerChargeLoader" color="red" size="20" indeterminate ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="editWarehouseChargeDialog" persistent max-width="350">
      <template>
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text">Update Warehouse Charge</v-card-title>
          <v-card-text>
            <v-container grid-list-xl fluid>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <!-- <v-flex xs12>
                    <v-text-field label="Warehouse Charge" min="1" type="number" v-model="warehouseCharge"></v-text-field>
                    <label class="custom-form-error milling-charge-error" for="contract"></label>
                  </v-flex> -->
                  <v-flex xs12>
                      <v-text-field
                        label="Warehouse Charge"
                        min="1"
                        type="number"
                        v-model="warehouseCharge"
                        :error-messages="chargeErrorMessages"
                        @input="validateCharge"

                      ></v-text-field>
                    </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="editWarehouseChargeDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="secondary"  @click="updateWarehouseCharge">Submit</v-btn>
            <v-progress-circular v-show="updateMillerChargeLoader" color="red" size="20" indeterminate ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline accent--text">Edit Record</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-if="selectedRecord" v-model="selectedRecord.eslipNumber" label="Eslip Number" readonly></v-text-field>

              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-if="selectedRecord"  v-model="selectedRecord.brokerAmount" label="Broker Amount" required>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-if="selectedRecord" v-model="selectedRecord.nceAmount" label="NCE Amount" required>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-if="selectedRecord" v-model="selectedRecord.growerCode" label="Grower Code" readonly>
                </v-text-field>
              </v-col>
            </v-row>


          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="white" class="accentd--text" style="font-weight: 700;"  @click="editDialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary"  @click="triggerEditRecord">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="approveRejectMillerChargeDialog" persistent max-width="500">
      <template>
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text">Miller Charge</v-card-title>
          <v-card-text v-if="approveStatus === 1">Do you want to approve the charge? </v-card-text>
          <v-card-text v-if="approveStatus === 0">Do you want to reject the charge? </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="approveRejectMillerChargeDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="approveStatus === 1" color="secondary"  @click="approveMillerCharge(1)">Approve</v-btn>
            <v-btn v-if="approveStatus === 0" color="secondary"  @click="approveMillerCharge(-1)">Reject</v-btn>
            <v-progress-circular v-show="approveMillerChargeLoader" color="red" size="20" indeterminate ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="approveRejectWarehouseChargeDialog" persistent max-width="500">
      <template>
        <v-card>
          <v-card-title class="headline accent&#45;&#45;text">Warehouse Charge</v-card-title>
          <v-card-text v-if="approveStatus === 1">Do you want to approve the charge? </v-card-text>
          <v-card-text v-if="approveStatus === 0">Do you want to reject the charge? </v-card-text>
          <v-card-actions>
            <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="approveRejectWarehouseChargeDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="approveStatus === 1" color="secondary"  @click="approveWarehouseCharge(1)">Approve</v-btn>
            <v-btn v-if="approveStatus === 0" color="secondary"  @click="approveWarehouseCharge(-1)">Reject</v-btn>
            <v-progress-circular v-show="approveMillerChargeLoader" color="red" size="20" indeterminate ></v-progress-circular>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
export default {
  name: 'growersettlement',
  data: function () {
    return {
      selectedRecord: null,
      nceBuyerPayment:[],
      payments: [],
      ncePayments: [],
      data: [],
      chargetypes: [],
      brokerPayments:[],
      growerPayments:[],
      millerPayments:[],
      chargeErrorMessages:[],
      millerchargeErrorMessages:[],
      warehousePayments:[],
      editMillerChargeDialog: false,
      editWarehouseChargeDialog: false,
      approveRejectMillerChargeDialog: false,
      approveRejectWarehouseChargeDialog: false,
      selectAll: false,
      message: '',
      loading: false,
      snackbar: false,
      snackbarColor: '',
      messsage: '',
      permissions: [],
      paginatedItems: [],
      editDialog: false,
      numberOfLinks: 0,
      millingCharge: 0,
      warehouseCharge:0,
      millingId: 0,
      warehouseId:0,
      approveStatus: 0,
      milling_id: 0,
      warehouse_id:0,
      approveMillerChargeLoader: false,
      updateMillerChargeLoader: false,
      numberOfItemsPerPage: 5,
      page: 1,
      search: '',
      invoice: {
        id: ''
      },
      chargetype: {
        id: '',
        name: ''
      },
      valid: true
    }
  },
  watch: {
    payments: function () {
      this.updatePagination()
    },
    page: function (val, oldVal) {
      // Check if the page change was triggered by a user action (e.g., selecting an item)
      if (val !== oldVal) {
        this.paginatedItems = this.paginationMethod(this.payments, val, this.numberOfItemsPerPage)
      }
    }
  },
  mounted () {

    this.getallChargeTypes()
    // this.getNcePayments()
    this.getBrokerPayments()
    this.getWarehousePaymentsByEslip()
    this.getMillerPayments()
    // this.getBuyerNcePaymentsByEslip()
    this.numberOfLinks = Math.ceil(this.payments.length / this.numberOfItemsPerPage)
    this.permissions = store.state.user.roleId.permissions
  },
  computed: {
    ...mapState({ user: state => state.user }),
    canUpdateMillingChargeOnSettlement: function () {
      return this.hasPerm('CAN_UPDATE_MILLER_CHARGE_ON_SETTLEMENT')
    },
    canApproveMillingChargeOnSettlement: function () {
      return this.hasPerm('CAN_APPROVE_MILLER_CHARGE_ON_SETTLEMENT')
    },
    filteredList: function () {
      if (this.search === '') {
        return this.paginatedItems
      } else {
        return this.payments.filter(payment => {
          const searchTerm = this.search.toLowerCase()
          var dateCreated = new Date(payment.dateCreated)
          return (
            (payment.eslipNumber?.toLowerCase()?.toString() ?? '').includes(searchTerm) ||
            (payment.lotNumber?.toLowerCase()?.toString() ?? '').includes(searchTerm) ||
            (payment.invoiceId?.toString() ?? '').includes(searchTerm) ||
            (payment.cleanCoffeeOutTurn?.toLowerCase() ?? '').includes(searchTerm) ||
            (payment.parchmentOutTurn?.toLowerCase() ?? '').includes(searchTerm) ||
            (payment.growerCode?.toLowerCase() ?? '').includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
          )
        })
        // return this.warrants.filter(warrant => { return warrant.outTurnNumber.toLowerCase().includes(this.search.toLowerCase()) })
      }
    },
    allEligibleRecordsSelected () {
      return this.filteredList
        .filter(item => this.canBeApproved1(item))
        .every(item => item.selected)
    }
  },
  methods: {
    ...mapActions({ editRecord: 'brokersettlement/editRecord' }),
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    updatePagination () {
      this.numberOfLinks = Math.ceil(this.payments.length / this.numberOfItemsPerPage)
      this.paginatedItems = this.paginationMethod(this.payments, this.page, this.numberOfItemsPerPage)
    },
    updateMillerAmount(item){
      console.log(item);
      $('.custom-form-error').css('display', 'none')
      this.editMillerChargeDialog = true
      this.millingCharge = item.millerAmount
      this.millingChargeOriginal = item.millerAmount
      this.millingId = item.id
    },
    updateWarehouseAmount(item){
      console.log(item);
      $('.custom-form-error').css('display', 'none')
      this.editWarehouseChargeDialog = true
      this.warehouseCharge = item.warehouseAmount
      this.warehouseChargeOriginal = item.warehouseAmount
      this.warehouseId = item.id
    },
    validateCharge() {
    let chargeValue = parseFloat(this.warehouseCharge); // Parse as float to handle decimal numbers

    // Round off to two decimal places using toFixed
    chargeValue = parseFloat(chargeValue.toFixed(2));

    if (isNaN(chargeValue) || chargeValue < 0 ) {
        this.chargeErrorMessages = [
            'Charge rate must be a number greater or equal to 0 '
        ];
    } else {
      this.warehouseCharge = chargeValue; // Update handling_charge with rounded value
        this.chargeErrorMessages = [];
    }
},
    validateMillingCharge() {
    let chargeValue = parseFloat(this.millingCharge); // Parse as float to handle decimal numbers

    // Round off to two decimal places using toFixed
    chargeValue = parseFloat(chargeValue.toFixed(2));


    if (isNaN(chargeValue) || chargeValue < 0.00 ) {
        this.millerchargeErrorMessages = [
            'Charge rate must be a number greater than or equal to 0 '
        ];
    } else {
      this.millingCharge = chargeValue; // Update handling_charge with rounded value
        this.millerchargeErrorMessages = [];
    }
},
    approveRejectChargeShowDialog (item, status) {
      console.log(item)
      console.log(status)
      this.approveStatus = status
      this.milling_id = item.id
      console.log("itemID ", this.milling_id)
      this.approveRejectMillerChargeDialog = true
    },
    approveRejectWarehouseChargeShowDialog (item, status) {
      console.log(item)
      console.log(status)
      this.approveStatus = status
      this.warehouse_id = item.id
      console.log("itemID ", this.warehouse_id)
      this.approveRejectWarehouseChargeDialog = true
    },
    updateMillingCharge(){
      $('.custom-form-error').css('display', 'none')
      if (this.millingCharge === '' || this.millingCharge < 0){
        $('.milling-charge-error').css('display', 'block')
        $('.milling-charge-error').text('Please enter a valid milling charge')
        return
      }

      this.updateMillerChargeLoader = true

      var url = config.serverURI + '/millerTransaction/updateAmount?id=' + this.millingId + '&amount=' + this.millingCharge + '&status=0'
      axios
        .put(url, {})
        .then(response => {
          var data = response.data
          var statusCode = data['statusCode'];
          this.updateMillerChargeLoader = false
          if (statusCode === 'OK'){
            this.editMillerChargeDialog = false
            this.message = 'Successfully updated miller charge'
            this.snackbar = true
            this.snackbarColor = 'primary'
            this.getMillerPayments()
            return
          } else {
            this.message = 'Something went wrong, please try again'
            this.snackbar = true
            this.snackbarColor = 'error'
          }
        })
        .catch(error => {
          this.updateMillerChargeLoader = false
          this.editMillerChargeDialog = false
          this.message = 'Something went wrong, please try again'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    updateWarehouseCharge(){
      $('.custom-form-error').css('display', 'none')
      if (this.warehouseCharge === '' || this.warehouseCharge < 0){
        $('.milling-charge-error').css('display', 'block')
        $('.milling-charge-error').text('Please enter a valid charge')
        return
      }

      this.updateMillerChargeLoader = true
      console.log('WarehouseCharge updated amount',typeof(warehouseCharge))
      var url = config.serverURI + '/warehouseTransaction/updateAmount?id=' + this.warehouseId + '&amount=' + this.warehouseCharge + '&status=0'
      axios
        .put(url, {})
        .then(response => {
          var data = response.data
          var statusCode = data['statusCode'];
          this.updateMillerChargeLoader = false
          if (statusCode === 'OK'){
            this.editWarehouseChargeDialog = false
            this.message = 'Successfully updated warehouse charge'
            this.snackbar = true
            this.snackbarColor = 'primary'
            this.getWarehousePaymentsByEslip()
            return
          } else {
            this.message = 'Something went wrong, please try again'
            this.snackbar = true
            this.snackbarColor = 'error'
          }
        })
        .catch(error => {
          this.updateMillerChargeLoader = false
          this.editWarehouseChargeDialog = false
          this.message = 'Something went wrong, please try again'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    approveMillerCharge (status) {
      const millerId = this.milling_id
      if (millerId !== '') {
        this.approveMillerChargeLoader = true;
        var url = config.serverURI + '/millerTransaction/approve?id=' + this.milling_id + '&status='+status
        axios
          .put(url, {})
          // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
          // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
          .then(response => {
            console.log("respzz => ", response.data);
            var data = response.data
            var statusCode = data['statusCode'];
            this.approveMillerChargeLoader = false
            if (statusCode === 'OK'){
              let message = 'Successfully approved miller charge'
              if (status === -1){
                message = 'Successfully rejected miller charge'
              }
              this.approveRejectMillerChargeDialog = false
              this.message = message
              this.snackbar = true
              this.snackbarColor = 'primary'
              this.getMillerPayments()
              return
            } else {
              this.message = 'Something went wrong, please try again'
              this.snackbar = true
              this.snackbarColor = 'error'
            }
          })
          .catch(error => {
            this.approveRejectMillerChargeDialog = false
            this.approveMillerChargeLoader = false
            this.message = 'Something went wrong, please try again'
            this.snackbar = true
            this.snackbarColor = 'error'
          })
      } else {
        this.message = 'Please enter all checkoffSettlementDetails'
        this.snackbar = true
        this.snackbarColor = 'error'
      }
    },
    approveWarehouseCharge (status) {
      const warehouseId = this.milling_id
      if (warehouseId !== '') {
        this.approveMillerChargeLoader = true;
        var url = config.serverURI + '/warehouseTransaction/approve?id=' + this.warehouse_id + '&status='+status
        axios
          .put(url, {})
          // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
          // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
          .then(response => {
            console.log("respzz => ", response.data);
            var data = response.data
            var statusCode = data['statusCode'];
            this.approveMillerChargeLoader = false
            if (statusCode === 'OK'){
              let message = 'Successfully approved warehouse charge'
              if (status === -1){
                message = 'Successfully rejected warehouse charge'
              }
              this.approveRejectWarehouseChargeDialog = false
              this.message = message
              this.snackbar = true
              this.snackbarColor = 'primary'
              this.getWarehousePaymentsByEslip()
              return
            } else {
              this.message = 'Something went wrong, please try again'
              this.snackbar = true
              this.snackbarColor = 'error'
            }
          })
          .catch(error => {
            this.approveRejectWarehouseChargeDialog = false
            this.approveMillerChargeLoader = false
            this.message = 'Something went wrong, please try again'
            this.snackbar = true
            this.snackbarColor = 'error'
          })
      } else {
        this.message = 'Please enter all checkoffSettlementDetails'
        this.snackbar = true
        this.snackbarColor = 'error'
      }
    },


    async getBrokerPayments () {
      console.log('Fetching broker payments...');
      try {
        const response = await axios.get(config.serverURI + '/brokerTransaction/getAllByUnbulkedId/' + this.$route.params.unbulkedid)
        this.brokerPayments = response.data
        console.log(this.brokerPayments)
        console.log('Length>>>',this.brokerPayments)
        // this.totalWarrants = this.brokerPayments.length
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    async getMillerPayments () {
      console.log('Fetching broker payments...');
      try {
        const response = await axios.get(config.serverURI + '/millerTransaction/getAllByUnbulkedId/' + this.$route.params.unbulkedid)
        this.millerPayments = response.data
        console.log(this.millerPayments)
        // this.totalWarrants = this.brokerPayments.length
        // this.updatePagination()
        this.numberOfLinks = Math.ceil(this.millerPayments.length / this.numberOfItemsPerPage)
        this.paginatedItems = this.paginationMethod(this.millerPayments, this.page, this.numberOfItemsPerPage)
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching payments')
      }
    },
    // async getNcePayments () {
    //   try {
    //     const response = await axios.get(config.serverURI + '/nceTransaction/getAllByEslipId/' + this.$route.params.eslipid)
    //     this.ncePayments = response.data
    //     this.updatePagination()
    //   } catch (error) {
    //     this.handleRequestError(error, 'Error occurred while fetching payments')
    //   }
    // },
    // async getBuyerNcePaymentsByEslip () {
    //           try {
    //               const response = await axios.get(config.serverURI + '/nceTransaction/getNceBuyerTransByEslipId/' + this.$route.params.eslipid)
    //               this.nceBuyerPayment = response.data
    //               console.log('NCE BUYER TRANSACTION',this.nceBuyerPayment)
    //               this.updatePagination()
    //           } catch (error) {
    //               console.log('Error occurred while fetching payments ' + error)
    //           }
    //       },

    async getallChargeTypes () {
      try {
        const response = await axios.get(config.serverURI + '/charges/getgrowerDeductions')
        this.chargetypes = response.data
        this.updatePagination()
      } catch (error) {
        this.handleRequestError(error, 'Error occurred while fetching chargetypes')
      }
    },
    canBeApproved1 (item) {
      return item.warrantNumber != null && item.approver1 == null && this.hasPerm('CAN_CONFIRM_WARRANT')
    },
    canBeApproved2 (item) {
      return item.approver1 != null && item.approver2 == null && this.hasPerm('CAN_CONFIRM_WARRANT')
    },
    hasPerm (permission) {
      return this.permissions.includes(permission)
    },
    onCheckboxChange (item) {
      // Handle checkbox change here
      // Update the paginated items without changing the page
      this.paginatedItems = this.paginationMethod(this.payments, this.page, this.numberOfItemsPerPage)
    },
    selectAllItems () {
      for (const item of this.payments) {
        item.selected = this.selectAll
      }
    },
    approveAction (unbulked) {
      this.disableInteraction = true;
      const url = config.serverURI + '/eslip/approveChargePayment'
      console.log('calling ' + url)
      axios.post(url, unbulked)
        .then(response => {
          this.approveloading = false
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            return
          }
          this.getPayments()
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
          this.snackbar = true
          this.snackbarColor = 'error'
          this.approveloading = false
        })
        .finally(() => {
          this.disableInteraction = false; // Re-enable interaction with the entire page
        });
      this.confirmDialog = false
    },
    approveActionForSelected () {
      const selectedItems = this.filteredList.filter(item => item.selected)
      const selectedItemsArray = []
      // Perform the approval action for selected items
      for (const item of selectedItems) {
        selectedItemsArray.push(item)
      }
      this.approveAction(selectedItemsArray)
    },
    updateChargeType () {
      const selectedChargeType = this.chargetypes.find(chargeType => chargeType.name === this.chargetype?.name)
      if (selectedChargeType) {
        console.log('Charge Name>>>',selectedChargeType.id)
        this.chargetype.name = selectedChargeType.name
        this.chargetype.id = selectedChargeType.id
        if (this.invoice !== null && selectedChargeType.name === 'NCE' ) {
          console.log('We are getting nce charges')
          this.getNcePaymentsByEslipAndInvoice(this.invoice)

        } else if (selectedChargeType.name === 'BROKER') {
          console.log('We are getting broker charges')
          this.getBrokerPayments()

        } else if (selectedChargeType.name === 'MILLER') {
          console.log('We are getting mILLER charges')
          this.getMillerPayments()

        }
        else if (selectedChargeType.name === 'WAREHOUSE') {
          console.log('We are getting warehouse charges')
          this.getWarehousePaymentsByEslip()

        }
        else {
          this.getNcePaymentsByEslip()
        }
      }
    },
    updateInvoiceId () {
      const selectedInvoice = this.data.find(invoice => invoice.id === this.invoice.id)
      this.invoice = selectedInvoice
    },
    // async getNcePaymentsByEslipAndInvoice (invoice) {
    //   try {
    //     const response = await axios.get(config.serverURI + '/nceTransaction/getAllByEslipIdAndInvoiceId/' + this.$route.params.eslipid + '/' + invoice.id)
    //     this.ncePayments = response.data
    //     console.log(this.ncePayments)
    //     this.updatePagination()
    //   } catch (error) {
    //     console.log('Error occurred while fetching payments ' + error)
    //   }
    // },
    // async getNcePaymentsByEslip () {
    //   try {
    //     const response = await axios.get(config.serverURI + '/nceTransaction/getAllByEslipId/' + this.$route.params.eslipid)
    //     this.ncePayments = response.data
    //     console.log(this.ncePayments)
    //     this.updatePagination()
    //   } catch (error) {
    //     console.log('Error occurred while fetching payments ' + error)
    //   }
    // },
    async getWarehousePaymentsByEslip () {
      try {
        const response = await axios.get(config.serverURI + '/warehouseTransaction/getAllByUnbulkedId/' + this.$route.params.unbulkedid)
        this.warehousePayments = response.data
        console.log('Warehouse Transactions>>>',this.warehousePayments)
        this.updatePagination()
      } catch (error) {
        console.log('Error occurred while fetching payments ' + error)
      }
    },
    showEditDialog (item) {
      this.selectedRecord=item
      // this.brokerPayments = item
      this.editDialog = true
    },
    triggerEditRecord () {
      this.editRecord(this.grnRecord).then(response => {
        if (response.data.error === false) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'primary', message: response.data.message })
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message })
        }
        this.$store.dispatch('grnfile/viewFile', this.$route.params.id)
        this.selected = []
        this.editDialog = false
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
        this.editDialog = false
      })
    },

  }
}

</script>
<style>

.custom-form-error {
  display: none;
  color: red;
}

.warrant_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.warrant_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.warrant_box:after, .warrant_box:before {
  right: 100%;
  top: 90%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.warrant_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.warrant_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}
</style>
